import React from 'react';
import PropTypes from 'prop-types';
import { useIntl, defineMessages } from 'react-intl';
import DataDrivenLogo from '../../data-driven-logo';
import USPSIcon from './usps-icon.png';
import USPSLogo from './usps-color.png';
import { CarrierEnums } from '../../../enums/carriers';
import { Providers } from '../../../enums/providers';

const EXPRESS1_PROVIDER_ID = 1;
const STAMPS_PROVIDER_ID = 2;
const ENDICIA_PROVIDER_ID = 5;
export const USPS_PROVIDER_IDS = [EXPRESS1_PROVIDER_ID, STAMPS_PROVIDER_ID, ENDICIA_PROVIDER_ID];

const DHL_EXPRESS_CARRIER_ID = Number(CarrierEnums.DhlExpress.carrierId);
const DHL_EXPRESS_PROVIDER_ID = Providers.DhlExpress.labelProviderIdInt;

const messages = defineMessages({
  uspsIcon: {
    defaultMessage: 'USPS Icon',
    id: 'N0+b/l',
    description: 'USPS Icon',
  },
  uspsLogo: {
    defaultMessage: 'USPS Logo',
    id: '1oykEf',
    description: 'USPS Logo',
  },
});

// WE HAVE TO HAVE THIS BECAUSE WE HAVE CARRIER COLUMN
// DO NOT USE THIS IN GENERAL
const CarrierLogo = ({ carrierId = 0, providerId, logoType = 'logo', ...rest }) => {
  const intl = useIntl();

  // specific handling as DHL's carrierId matches with USPS's endicia providerId
  const isDHLExpress = carrierId === DHL_EXPRESS_CARRIER_ID && providerId === DHL_EXPRESS_PROVIDER_ID;

  if (isDHLExpress || !USPS_PROVIDER_IDS.includes(carrierId)) {
    return <DataDrivenLogo carrierId={carrierId} logoType={logoType} providerId={providerId} {...rest} />;
  }
  return logoType === 'icon' ? (
    <img src={USPSIcon} {...rest} alt={intl.formatMessage(messages.uspsIcon)} />
  ) : (
    <img src={USPSLogo} {...rest} alt={intl.formatMessage(messages.uspsLogo)} />
  );
};

CarrierLogo.propTypes = {
  providerId: PropTypes.number,
  carrierId: PropTypes.number,
  logoType: PropTypes.oneOf(['icon', 'logo']),
};

export default CarrierLogo;
